export default __webpack_public_path__ + "static/media/reuse.39d456d6.png";